/*
 * @Author: zhangyugegeliuchen@didichuxing.com 
 * @Date: 2019-01-08 18:16:03
 * @Last Modified by: zhangyugegeliuchen@didichuxing.com
 * @Last Modified time: 2019-01-08 18:16:03
 * @Description:  btd落地页
 */
<template>
  <Creater :name="componetName" v-if="configInfo"></Creater>
</template>
<script>
import landingPage from './landingPage'
// import noActivity from './noActivity'
import Creater from './modules/pageCreater'
import { getShopInfo, getUserInfo } from '@/common/js/bridge'
import Schema from '@/common/js/schema'
import { xtdConfigSchema } from '@/store/d/schema'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'btdLandingPage',
  components: {
    Creater
  },
  data () {
    return {
      configInfo: null
    }
  },
  computed: {
    ...mapGetters(['globalParams', 'xtdConfig']),
    meanfulXtdConfigInfo () {
      return Schema.compare(this.xtdConfig, xtdConfigSchema)
    },
    componetName () {
      let validate = this.meanfulXtdConfigInfo && this.xtdConfig.validation
      switch (validate) {
        case 1:
          return landingPage
        default:
          return landingPage
      }
    }
  },
  methods: {
    ...mapActions(['getGlobalInfo', 'getXtdConfigInfo', 'getShopInfos']),
    getSourceInfo () {
      if (this.isInDApp) {
        return Promise.all([this.getGlobalInfo(), getUserInfo()])
          .then((data) => {
            return {
              ...data[0],
              ...data[1],
              sourceType: 'd',
              sourceID: data[1].uid
            }
          })
          .catch((err) => {
            console.log('err', err)
          })
      } else if (this.isInBApp || this.isIPad) {
        return Promise.all([this.getGlobalInfo(), getShopInfo()])
          .then((data) => {
            return {
              ...data[0],
              ...data[1],
              sourceType: 'b',
              sourceID: data[1].shopId
            }
          })
      }
      return Promise.resolve({})
    },
    async fetchAcquisitionConfig (data) {
      let res = await this.getXtdConfigInfo(data)
      if (res && res.errno === 0 && res.data) {
        this.configInfo = res.data
      } else {
        this.configInfo = {}
        throw res && res.errmsg
      }
    }
  },
  created () {
    this.getSourceInfo()
      .then((data) => {
        return this.fetchAcquisitionConfig(data)
      })
  }
}
</script>
<style>
</style>
